export default "__VITE_ASSET__MyQVsc$i__"